import { render, staticRenderFns } from "./admissionFormCreateApprovers.vue?vue&type=template&id=a37664d6"
import script from "./admissionFormCreateApprovers.vue?vue&type=script&lang=js"
export * from "./admissionFormCreateApprovers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports